export const options = [
  { text: "calculator-suite.forex", value: "forex" },
  { text: "calculator-suite.stocks", value: "stock" },
];
export const leverageMT45XLEV = [
  {
    name: "1:1",
    code: "1",
  },
  {
    name: "1:2",
    code: "2",
  },
  {
    name: "1:5",
    code: "5",
  },
  {
    name: "1:10",
    code: "10",
  },
  {
    name: "1:20",
    code: "20",
  },
  {
    name: "1:30",
    code: "30",
  },
];
export const optionsCurrencyForex = [
  { text: "USD", value: "usd" },
  { text: "EUR", value: "eur" },
  { text: "GBP", value: "gbp" },
  { text: "CHF", value: "chf" },
  { text: "PLN", value: "pln" },
];
export const typeContract = [
  { text: "Standard", value: "Standard" },
  { text: "Micro", value: "Micro" },
  { text: "Mini", value: "Mini" },
];
export const currenciesConvertor = [
  { text: "USD", value: "USD" },
  { text: "USDT", value: "USDT" },
  { text: "BTC", value: "BTC" },
  { text: "LTC", value: "LTC" },
  { text: "ETH", value: "ETH" },
  { text: "XRP", value: "XRP" },
  { text: "EUR", value: "EUR" },
  { text: "GBP", value: "GBP" },
  { text: "JPY", value: "JPY" },
  { text: "CHF", value: "CHF" },
  { text: "CAD", value: "CAD" },
  { text: "AUD", value: "AUD" },
  { text: "NZD", value: "NZD" },
  { text: "CNY", value: "CNY" },
  { text: "HKD", value: "HKD" },
  { text: "SGD", value: "SGD" },
  { text: "KRW", value: "KRW" },
  { text: "INR", value: "INR" },
  { text: "BRL", value: "BRL" },
  { text: "MXN", value: "MXN" },
  { text: "ARS", value: "ARS" },
  { text: "CLP", value: "CLP" },
  { text: "COP", value: "COP" },
  { text: "PEN", value: "PEN" },
  { text: "ZAR", value: "ZAR" },
  { text: "RUB", value: "RUB" },
  { text: "TRY", value: "TRY" },
  { text: "AED", value: "AED" },
  { text: "THB", value: "THB" },
  { text: "IDR", value: "IDR" },
  { text: "PHP", value: "PHP" },
  { text: "VND", value: "VND" },
  { text: "PLN", value: "PLN" },
];
export const resultKeyMap = {
  p: "pivot_point",
  P: "pivot_point",
  pivot_point: "pivot_point",

  s1: "s1",
  S1: "s1",
  first_support: "s1",

  s2: "s2",
  S2: "s2",
  second_support: "s2",

  r1: "r1",
  R1: "r1",
  first_resistance: "r1",

  r2: "r2",
  R2: "r2",
  second_resistance: "r2",

  breakout_pivot: "breakout_pivot",
  lower_target: "lower_target",
  upper_target: "upper_target",
};
